import gql from "graphql-tag";
import { isMobile } from "shared/util/EnvironmentHelpers";
import { useQuery } from "@apollo/react-hooks";
import get from "lodash/get";
import Context from "shared/util/Context";

const SMS_KILL_SWITCH_QUERY = gql`
	query WebSmsKillSwitches {
		auth {
			smsKillSwitches {
				desktop
				mobileWeb
			}
		}
	}
`;

const shouldDisableSms = (data) => get(data, `auth.smsKillSwitches.${isMobile ? "mobileWeb" : "desktop"}`);

export default function useSmsKillSwitch() {
	const { loading, error, data } = useQuery(SMS_KILL_SWITCH_QUERY);
	const disableSms = Context.has("SMS_KILL_SWITCH") || !loading && data && shouldDisableSms(data);

	return { loading, error, data, disableSms };
}



// WEBPACK FOOTER //
// ./src/shared/hooks/useSmsKillSwitch.js